// extracted by mini-css-extract-plugin
module.exports = {"microsoftAdsCard":"uz-z"};